export const LOCALE_REGEX_PATTERN = /^(?<locale>(?<lang>[a-z]{2})(?:(?<separator>[-_])(?<country>[a-z0-9]+))?)$/i;
//# sourceMappingURL=constants.js.map